(ns storrito.editor.countdown-sticker
  (:require ["fabric" :refer [fabric]]
            [storrito.editor.sticker-design :as sticker-design]
            [clojure.string :as str]
            [cljs-time.core :as t]
            [cljs-time.coerce :as tc]
            goog.string
            ))

;; Concept:
;;
;; Creates a FabricJS object that looks like an Instagram quiz
;; sticker.

(def countdown-width 692)
(def countdown-height 432)
;; 427 433

(defn set-background-gradient
  [fabric-element color-1 color-2]
  (.set fabric-element
        "fill"
        (js/fabric.Gradient.
          #js{:coords #js{:x1 0
                          :y1 0
                          :x2 countdown-width
                          :y2 countdown-height}
              :type "linear"
              :gradientUnits "pixels"
              :colorStops #js[#js{:offset 0 :color color-1}
                              #js{:offset 1 :color color-2}]})))

(defn digit-card
  [{:keys [card-color digit-color top left text]}]
  (let [rect (js/fabric.Rect. #js{:fill card-color
                                  :width 78
                                  :height 130
                                  :rx 11
                                  :ry 11})
        text (js/fabric.Text. text
                              #js{:fill digit-color
                                  :originX "center"
                                  :originY "center"
                                  :breakWords true
                                  :splitByGrapheme true
                                  :lineHeight 1
                                  :fontSize 70
                                  :left 40
                                  :top 65
                                  :fontFamily "AvenyT"})]
    (js/fabric.Group. (into-array [rect text])
                      #js{:top top
                          :left left
                          :originX "left"
                          :originY "bottom"})))

(defn digit-cards
  [{:keys [card-color digit-color top left text]}]
  (let [digit-1 (digit-card {:card-color card-color
                             :digit-color digit-color
                             :top 0
                             :left 0
                             :text (first text)})
        digit-2 (digit-card {:card-color card-color
                             :digit-color digit-color
                             :top 0
                             :left 84
                             :text (second text)})]
    (js/fabric.Group. (into-array [digit-1 digit-2])
                      #js{:top top
                          :left left
                          :originX "left"
                          :originY "bottom"})))

(defn digit-card-label
  [{:keys [fill text left top]}]
  (js/fabric.Text. text
                   #js{:fill fill
                       :breakWords true
                       :splitByGrapheme true
                       :originX "left"
                       :originY "bottom"
                       :width 460
                       :height 100
                       :top top
                       :lineHeight 1
                       :left left
                       :fontSize 32
                       :fontFamily "Roboto"
                       :fontWeight "bold"}))

(defn colon
  [{:keys [fill top left]}]
  (let [dot (fn [top]
              (js/fabric.Rect. #js{:fill fill
                                   :width 8
                                   :height 8
                                   :rx 0
                                   :ry 0
                                   :originX "left"
                                   :originY "bottom"
                                   :top top}))]
    (js/fabric.Group. (into-array [(dot 0)
                                   (dot 28)])
                      #js{:top top
                          :left left
                          :originY "bottom"})))

(defn arrow-circle
  [{:keys [left top fill]}]
  (let [circle (js/fabric.Circle. #js{:fill "rgba(0,0,0,0)"
                                      :radius 30
                                      :strokeWidth 4
                                      :stroke fill
                                      :opacity 0.8
                                      })
        arrow (js/fabric.Polyline. (clj->js [{:x 0 :y 0}
                                             {:x 15 :y 13}
                                             {:x 0 :y 26}])
                                   #js{:fill "rgba(0,0,0,0)"
                                       :stroke fill
                                       :opacity 0.8
                                       :strokeWidth 4
                                       :top 16
                                       :left 23
                                       :originX "left"
                                       :originY "top"})]
    (js/fabric.Group. (into-array [circle arrow])
                      #js{:left left
                          :top top
                          :originY "bottom"})
    ))

(defn textbox
  [{:keys [text fill]}]
  (let [text (str/upper-case text)
        textbox (js/fabric.Textbox. text
                                    #js{:fill fill
                                        :breakWords true
                                        :splitByGrapheme true
                                        :originX "left"
                                        :originY "center"
                                        :width 460
                                        :top -330
                                        :lineHeight 1
                                        :left 72
                                        :fontSize 56
                                        :fontFamily "AvenyT"
                                        :fontWeight "bold"})
        text (->> (get (js->clj (._splitTextIntoLines textbox text))
                       "lines")
                      (take 2)
                  (map (fn [s]
                         (str/trim s)))
                  (str/join
                    "\n"))]
    (set! (.-text textbox) text)
    (.calcTextHeight textbox)
    textbox))

(defn interval->map
  [{:keys [start end] :as interval}]
  (let [years (t/in-years interval)
        months (mod (t/in-months interval)
                    12)
        hours (t/in-hours interval)
        minutes (t/in-minutes interval)
        seconds (t/in-seconds interval)
        start+years+months (t/plus start
                                   (t/years years)
                                   (t/months months))
        new-interval (t/interval start+years+months
                                 end)]
    {:years years
     :months (mod months
                  12)
     :days (t/in-days new-interval)
     :hours (mod hours 24)
     :minutes (mod minutes 60)
     :seconds (mod seconds 60)}))

(defn get-nth-label
  [n precise-interval]
  (let [[k v] (-> (into [] precise-interval)
                  (nth (dec n)))
        plural (name k)]
    (if (> v 1)
      plural
      (subs plural
            0 (dec (count plural))))))

(defn get-nth-text
  [n precise-interval]
  (let [[_k v] (-> (into [] precise-interval)
                   (nth (dec n)))]
    (goog.string/padNumber v 2)))

(defn time-until
  [time-stamp]
  (let [interval (t/interval (t/now)
                             time-stamp)]
    (->> (interval->map interval)
         (drop-while
           (fn [[k v]]
             (and
               (not= k :hours)
               (zero? v))))
         (take 3)
         (into {}))))

(defn countdown-sticker
  "Builds the fabricjs representation of an Instagram countdown sticker"
  [{:keys [text
           start_background_color
           end_background_color
           digit_color
           digit_card_color
           end_ts
           text_color]
    :or {text "COUNTDOWN NAME"
         start_background_color "#ca2ee1"
         end_background_color "#5eb1ff"
         digit_color "#7e0091"
         digit_card_color "#ffffff"
         end_ts (t/plus (t/now)
                        (t/days 1))
         text_color "#ffffff"}
    :as params}]

  (let [time-until (time-until end_ts)]

    (js/fabric.util.clearFabricFontCache)
    (let [shadow #js{:color "rgba(0, 0, 0, 0.5)",
                     :blur 5,
                     :offsetX 3,
                     :offsetY 3,
                     :affectStroke false}
          gradient (js/fabric.Gradient. (clj->js {:type "linear"
                                                  :gradientUnits "percentage"
                                                  :coords {:x1 0
                                                           :y1 0
                                                           :x2 1
                                                           :y2 1}
                                                  :colorStops [{:offset 0
                                                                :color start_background_color}
                                                               {:offset 1
                                                                :color end_background_color}]}))
          text-object (textbox {:text text
                                :fill text_color})


          panel-object (js/fabric.Rect. #js{:fill gradient
                                            :width countdown-width
                                            :height countdown-height
                                            :rx 30
                                            :ry 30
                                            :originX "left"
                                            :originY "bottom"
                                            :shadow shadow})

          digit-cards-1 (digit-cards {:card-color digit_card_color
                                      :digit-color digit_color
                                      :top -119
                                      :left 67
                                      :text (get-nth-text 1 time-until)})

          label-1 (digit-card-label {:fill text_color
                                     :text (get-nth-label 1 time-until)
                                     :left 67
                                     :top -60})

          colon-1 (colon {:fill digit_card_color
                          :top -168
                          :left 242})

          digit-cards-2 (digit-cards {:card-color digit_card_color
                                      :digit-color digit_color
                                      :top -119
                                      :left 265
                                      :text (get-nth-text 2 time-until)})

          label-2 (digit-card-label {:fill text_color
                                     :text (get-nth-label 2 time-until)
                                     :left 265
                                     :top -60})

          colon-2 (colon {:fill digit_card_color
                          :top -168
                          :left 441})

          digit-cards-3 (digit-cards {:card-color digit_card_color
                                      :digit-color digit_color
                                      :top -119
                                      :left 462
                                      :text (get-nth-text 3 time-until)})

          label-3 (digit-card-label {:fill text_color
                                     :text (get-nth-label 3 time-until)
                                     :left 462
                                     :top -60})

          circle (arrow-circle {:fill text_color
                                :left 555
                                :top -303})]

      (js/fabric.Group. (into-array [panel-object
                                     text-object
                                     circle
                                     digit-cards-1
                                     label-1
                                     colon-1
                                     digit-cards-2
                                     label-2
                                     colon-2
                                     digit-cards-3
                                     label-3
                                     ])
                        #js{:id "countdown-sticker"
                            :max-scale 1.5
                            :min-scale 0.3
                            :top (or (:top params) 10)
                            :left (or (:left params) 10)
                            :angle (or (:angle params) 0.0)
                            :scaleY (or (:scaleX params) 1.0)
                            :scaleX (or (:scaleY params) 1.0)
                            :countdown #js{:text text
                                           :start_background_color start_background_color
                                           :end_background_color end_background_color
                                           :digit_color digit_color
                                           :digit_card_color digit_card_color
                                           :end_ts (tc/to-epoch end_ts)
                                           :text_color text_color}})
      )))
